export default () => import(/* webpackChunkName: 'coffee/app/agreement/coffee-personality-test' */ './CoffeePersonalityTest');
